import React from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import MainIcon from '@material-ui/icons/Beenhere';
import FilterListIcon from '@material-ui/icons/FilterList';
import { t } from 'ttag';
import useRouter from 'use-react-router';
import { useApolloClient } from '@apollo/react-hooks';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DataTable from '../../../components/DataTable';
import {
  BASE_STATUS,
  BASE_STATUS_TITLES,
  USER_STATUS,
  USER_STATUS_OPTIONS,
} from '../../../utils/enums';
import useUser from '../../../auth/hooks';
import useApi, { MyClubCApi } from '../../../api';
import { insertAt, prepareParam } from '../../../utils/helpers';
import ReasonDialogForm from '../../../components/ReasonDialogForm';
import AthleteViewDialog from '../../../components/AthleteViewDialog';
import { extractDataError } from '../../../utils/errors';
import useNotifier from '../../../components/Messages/hooks';
import queryString from 'query-string';
import { MTableToolbar } from 'material-table';
import Pagination from '@material-ui/lab/Pagination';
import { useNavigator } from '../../../components/Navigator';
import { SearchInput } from '../../../components/MaterialToolBarSearchInput';
import Loading from '../../../components/Loading';
import { AddGroupModalController } from '../components/AddGroupModal';
import DownloadFileDialog from '../../../components/DownLoadFileDialog';
import { v4 as uuidv4 } from 'uuid';

const ListView = () => {
  const navigate = useNavigator();
  const { user } = useUser();
  const api = useApi();
  const pushMessage = useNotifier();
  const { history } = useRouter();
  const client = useApolloClient();
  const newApi = new MyClubCApi(client);

  const [state, setState] = React.useState({ objId: null });
  const [showReasonDialog, setStateShowReasonDialog] = React.useState({
    objId: null,
  });
  const [showAddGroupDialog, setShowAddGroupDialog] = React.useState({
    objId: null,
  });
  const [loading, setLoading] = React.useState(false);
  const [iconLoading, setIconLoad] = React.useState(false);

  const [athletes, setAthletes] = React.useState([]);
  const [trainers, setTrainers] = React.useState([]);
  const [gyms, setGyms] = React.useState([]);
  const [sections, setSections] = React.useState([]);
  const [pageInfo, setPageInfo] = React.useState({});
  const searchParams = new URLSearchParams(history.location.search);
  const intervalId = React.useRef(null);
  const [generateFileStatus, setGenerateFileStatus] = React.useState(null);
  const [isPopupOpen, setIsPopupOpen] = React.useState(false);
  const [requestID, setRequestID] = React.useState("");

  const [pageState, setPageState] = React.useState({
    status: parseInt(searchParams.get('status'), 10) || USER_STATUS.active,
    trainerId: parseInt(searchParams.get('trainerId'), 10),
    gymId: parseInt(searchParams.get('gymId'), 10),
    sectionTypeId: parseInt(searchParams.get('sectionTypeId'), 10) || undefined,
    page: parseInt(searchParams.get('page'), 10) || 1,
    query: searchParams.get('query') || undefined,
    limit: 50,
  });

  const updateHistory = (searchParams) => {
    history.replace({
      search: `?${queryString.stringify(searchParams)}`,
    });
  };

  const fetchAthletes = async () => {
    setLoading(true);
    const finalParams = prepareParam(pageState);
    updateHistory(finalParams);
    const data = await newApi.getPaginatedAthletes(finalParams);
    setAthletes(data.items);
    setPageInfo(data.pageInfo);
    setLoading(false);
  };

  React.useEffect(() => {
    async function fetchData() {
      const trainersData = await newApi.getTrainers({
        status: USER_STATUS.active,
      });
      const gyms = await newApi.getGyms();
      const sectionsData = await newApi.getSections();
      setSections(sectionsData);
      setTrainers([{ fullInitials: 'Немає тренера', id: 0 }, ...trainersData]);
      setGyms([{ name: 'Немає залу', id: 0 }, ...gyms]);
    }
    fetchData();
  }, []);

  React.useEffect(() => {
    fetchAthletes();
  }, [pageState]);

  const generateAthletesXlsStatus = async () => {
    const status = await newApi.generateAthletesXlsStatus(requestID)
    setGenerateFileStatus(status)
    if (status.progress === "100") {
      pushMessage({ text: t`Успішно сгенеровано` });
    }
  };

  const generateAthletesXls = () => {
    setIsPopupOpen(true);
  };

  const doGenerateAthletesXls = async () => {
    setIconLoad(true);
    const finalParams = prepareParam(pageState);
    const newRequestID = uuidv4()
    setRequestID(newRequestID)
    const res = await newApi.generateAthletesXls(newRequestID, finalParams);
    if (res.ok) {
      pushMessage({ text: t`Почато завантаження` });
    } else {
      const dataError = extractDataError(res.errors);
      pushMessage({ text: dataError });
      setIconLoad(false);
      setIsPopupOpen(false)
    }
  };

  React.useEffect(() => {
    if (!iconLoading || !isPopupOpen) return;

    intervalId.current = setInterval(() => {
      generateAthletesXlsStatus();
    }, 5000);

    return () => clearInterval(intervalId.current);
  }, [iconLoading, isPopupOpen]);


  const handleSetPage = async (e, p) => {
    const newPageState = { ...pageState, page: p };
    setPageState(newPageState);
  };
  const handleSetFilter = async (name, value) => {
    const newPageState = { ...pageState, page: 1, [name]: value };
    setPageState(newPageState);
  };

  const onEdit = (e, data) => {
    navigate(api.router.athletes.edit(data.id));
  };

  // const onAdd = () => {
  //   navigate(api.router.athletes.create());
  // };

  const onDelete = async (data) => {
    const res = await newApi.deleteAthlete(data.id);
    if (res.ok) {
      pushMessage({ text: t`Успішно видалено` });
    } else {
      const dataError = extractDataError(res.errors);
      pushMessage({ text: dataError });
    }
    await fetchAthletes();
  };

  const onArchivate = async (athleteId, reason) => {
    const res = await newApi.archivateAthlete(athleteId, reason);
    if (res.ok) {
      pushMessage({ text: t`Успішно додано до архіву` });
    } else {
      const dataError = extractDataError(res.errors);
      pushMessage({ text: dataError });
    }
    await fetchAthletes();
  };

  const handleOnView = (d) => {
    setState({ ...state, objId: d.id });
  };

  const handleOnArchive = (rowData) => {
    setStateShowReasonDialog({ ...showReasonDialog, objId: rowData.id });
  };

  const handleOnActivate = async (rowData) => {
    setShowAddGroupDialog({ ...showAddGroupDialog, objId: rowData.id });
  };

  const columns = [
    { title: t`Id`, field: 'id', editable: 'never' },
    { title: t`Прізвище`, field: 'lastName' },
    { title: t`Ім'я`, field: 'firstName' },
    { title: t`По-батькові`, field: 'middleName' },
    {
      title: t`Зал`,
      field: 'gyms',
      render: ({ gyms }) =>
        gyms.map((g) => (
          <Chip key={g.id} variant='outlined' size='small' label={g.name} />
        )),
    },
    {
      title: t`Спорт`,
      field: 'sections',
      render: ({ sections }) =>
        sections.map((s) => (
          <Chip key={s.id} variant='outlined' size='small' label={s.name} />
        )),
    },
    {
      title: t`Тренер`,
      field: 'trainers',
      editable: 'never',
      render: ({ trainers, mainTrainerId }) =>
        trainers.map((trainer) => (
          <Chip
            key={trainer?.id}
            variant='outlined'
            size='small'
            label={trainer?.fullInitials}
            color='primary'
            icon={
              mainTrainerId === trainer?.id ? (
                <Tooltip title={t`Головний тренер`}>
                  <MainIcon />
                </Tooltip>
              ) : null
            }
            onClick={() => {
              window.open(api.router.trainers.edit(trainer.id));
            }}
          />
        )),
    },
    {
      title: t`Статус`,
      field: 'status',
      render: ({ status }) => {
        const colorMap = {
          [BASE_STATUS.blocked]: 'secondary',
          [BASE_STATUS.active]: 'primary',
        };
        return (
          <Chip
            size='small'
            label={BASE_STATUS_TITLES[status]}
            color={colorMap[status] || 'default'}
            variant='default'
          />
        );
      },
    },
  ];
  const adminColumns = [
    { title: t`Клуб`, field: 'club', render: ({ club }) => club.shortName },
  ];
  user.isAdmin && insertAt(columns, 1, ...adminColumns);

  if (loading) return <Loading />;

  return (
    <Paper>
      {/*TODO use MaterialTable */}
      <DataTable
        pageSize={Math.min(pageState.limit, athletes.length)}
        processLoading={iconLoading}
        search={false}
        isLoading={loading}
        title={t`Список cпортсменів`}
        columns={columns}
        data={athletes}
        // onAdd={onAdd}
        onEdit={onEdit}
        onArvitate={(event, rowData) => handleOnArchive(rowData)}
        onActivate={(event, rowData) => handleOnActivate(rowData)}
        onDelete={user.isAdmin ? onDelete : null}
        onView={handleOnView}
        onGenerateXls={generateAthletesXls}
        components={{
          Pagination: () => (
            <Grid container style={{ marginTop: '10px', marginBottom: '10px' }}>
              <Grid item style={{ margin: '0 auto' }}>
                <Pagination
                  size='medium'
                  count={pageInfo.pages}
                  page={pageState.page}
                  color='primary'
                  onChange={handleSetPage}
                />
              </Grid>
            </Grid>
          ),
          Toolbar: (props) => (
            <div>
              <MTableToolbar {...props} />
              <Grid
                container
                spacing={2}
                style={{ marginLeft: '10px' }}
                justifyContent='flex-start'
                alignItems='center'
              >
                <Grid item>
                  <Tooltip title={t`Виберіть фільтр`}>
                    <FilterListIcon />
                  </Tooltip>
                </Grid>
                <Grid item sm={2}>
                  <Autocomplete
                    size='small'
                    options={USER_STATUS_OPTIONS}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t`Виберіть статус`}
                        variant='outlined'
                      />
                    )}
                    value={USER_STATUS_OPTIONS.find(
                      (item) => item && item.id === pageState.status
                    )}
                    onChange={(e, value) =>
                      handleSetFilter('status', value && value.id)
                    }
                  />
                </Grid>
                <Grid item sm={2}>
                  <Autocomplete
                    size='small'
                    options={trainers}
                    getOptionLabel={(option) => option.fullInitials}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t`Виберіть тренера`}
                        variant='outlined'
                      />
                    )}
                    value={trainers.find(
                      (item) => item && item.id === pageState.trainerId
                    )}
                    onChange={(e, value) =>
                      handleSetFilter('trainerId', value && value.id)
                    }
                  />
                </Grid>
                <Grid item sm={2}>
                  <Autocomplete
                    size='small'
                    options={gyms}
                    getOptionLabel={(option) => option.name}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t`Виберіть зал`}
                        variant='outlined'
                      />
                    )}
                    value={gyms.find((g) => g && g.id === pageState.gymId)}
                    onChange={(e, value) =>
                      handleSetFilter('gymId', value && value.id)
                    }
                  />
                </Grid>
                <Grid item sm={2}>
                  <Autocomplete
                    size='small'
                    options={sections}
                    getOptionLabel={(option) => option.name}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t`Виберіть вид спорту`}
                        variant='outlined'
                      />
                    )}
                    value={sections.find(
                      (section) =>
                        section && section.id === pageState.sectionTypeId
                    )}
                    onChange={(e, value) =>
                      handleSetFilter('sectionTypeId', value && value.id)
                    }
                  />
                </Grid>
                <Grid item sm={2}>
                  <SearchInput
                    value={pageState.query}
                    onChange={(value) => handleSetFilter('query', value)}
                  />
                </Grid>
              </Grid>
              {!loading && (
                <Grid container style={{ margin: '10px 0 0 15px' }}>
                  <Grid item>
                    <Typography>
                      {t`Знайдено `} <b>{pageInfo.total}</b>{' '}
                    </Typography>
                  </Grid>
                </Grid>
              )}
            </div>
          ),
        }}
      />
      {isPopupOpen && (
        <DownloadFileDialog
          loading={iconLoading}
          onClose={() => {
            setIsPopupOpen(false)
            setIconLoad(false)
          }}
          onAccept={doGenerateAthletesXls}
          progress={generateFileStatus? generateFileStatus.progress : 0}
          file={generateFileStatus? generateFileStatus.url : null}
        />
      )}
      <AthleteViewDialog
        open={!!state.objId}
        objId={state.objId}
        onClose={() => setState({ ...state, objId: null })}
      />
      {showReasonDialog.objId && (
        <ReasonDialogForm
          open={!!showReasonDialog.objId}
          onClose={() => setStateShowReasonDialog({ ...state, objId: null })}
          onAccept={async (data) => {
            await onArchivate(showReasonDialog.objId, data.reason);
            setStateShowReasonDialog({ ...state, objId: null });
          }}
        />
      )}
      {showAddGroupDialog.objId && (
        <AddGroupModalController
          athleteId={showAddGroupDialog.objId}
          onClose={() => setShowAddGroupDialog({ ...state, objId: null })}
          onAccept={async (res) => {
            if (res.ok) {
              pushMessage({ text: t`Успішно активовано` });
            } else {
              const dataError = extractDataError(res.errors);
              pushMessage({ text: dataError });
            }
            setShowAddGroupDialog({ ...state, objId: null });
            await fetchAthletes();
          }}
        />
      )}
    </Paper>
  );
};

export default ListView;
